import React, { useEffect, useRef, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import SignaturePad from "react-signature-canvas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import userActions from "../../_actions/userActions";
import AlertModal from "../_common/AlertModal";

export default function EditUserSignatureModal(props) {
  const { showModal, toggleModal, userId, tabId } = props;

  const [signature, setSignature] = useState(null);

  const dispatch = useDispatch();

  const fetchingUser = useSelector((state) => state.users.fetching);
  const existSignatureData = useSelector(
    (state) => state.users.miscSessionData.userSignature || null
  );

  const [showAlert_signPadEmpty, setShowAlert_signPadEmpty] = useState(false);
  const toggelAlert_signPadEmpty = () =>
    setShowAlert_signPadEmpty(!showAlert_signPadEmpty);

  // Load existing signature when initializing.
  // Signature could have been created in User Preferences module.
  useEffect(() => {
    const getUserSig = async (userId) => {
      const suppressWarning = true;
      await dispatch(userActions.getSignature(userId, suppressWarning));
    };
    if (!existSignatureData) getUserSig(userId);
    else setSignature(existSignatureData.dataUrl);
  }, [userId]);

  useEffect(() => {
    if (existSignatureData?.dataUrl) setSignature(existSignatureData.dataUrl);
  }, [existSignatureData]);

  /** @type {React.MutableRefObject<SignaturePad>} */
  const signPadRef = useRef(null);

  const handleClick_clear = (e) => {
    e.preventDefault();
    if (signature) setSignature(null);
    else signPadRef.current.clear();
  };

  const handleClick_sign = async (e) => {
    e.preventDefault();
    const sigData = {
      dataUrl: signPadRef.current
        ? signPadRef.current.getTrimmedCanvas().toDataURL("image/png")
        : "",
      createdOn: new Date(),
    };

    // If signature pad is shown:
    // 1. If empty, remind user to sign and do not proceed with submit
    // 2. If a signature is drawn but one already exists on file, add signature as
    //    a newer version, then submit
    // 3. If a signature is drawn and no signature exists on file, add signature,
    //    then submit
    // (Case #2 would happen if the existing signature was initially loaded or user
    // clicked "Use Existing", but then proceeded to press "Clear" and enable SignaturePad.)
    if (signPadRef.current) {
      if (signPadRef.current.isEmpty()) {
        toggelAlert_signPadEmpty();
        return;
      } else {
        await dispatch(userActions.addSignature(userId, sigData));
      }
    }
    // If signature pad is not shown, do not proceed if 'signature' is empty.
    else if (!signature) {
      alert("No signature provided.");
      return;
    }

    toggleModal();
  };

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <>
      <Modal isOpen={showModal} size="md">
        <ModalHeader className="bg-info text-white" close={closeBtn}>
          <FontAwesomeIcon icon="file-signature" className="fa-fw mr-2" />
          Create/Change Signature
        </ModalHeader>
        <ModalBody>
          <div className="card">
            <div className="card-body m-2 p-2">
              <div className="form-row form-group mb-2">
                <label htmlFor="signature" className="mb-1">
                  Signature:
                </label>
                <div className="adr-sign__signpad">
                  {!fetchingUser ? (
                    signature ? (
                      <img
                        src={signature}
                        alt="Author Signature"
                        style={{ width: "100%", height: "100%" }}
                      />
                    ) : (
                      <SignaturePad
                        canvasProps={{ style: { width: "100%", height: "100%" } }}
                        ref={(ref) => (signPadRef.current = ref)}
                        onEnd={() => {}}
                      />
                    )
                  ) : (
                    "Loading..."
                  )}
                </div>
              </div>
              <div className="form-row form-group mb-2 d-flex flex-row">
                <div>
                  <button
                    id="clearSignature"
                    name="clearSignature"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={handleClick_clear}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="bg-lightgray">
          <div className="form-row form-group">
            <button
              id="cancelSubmit"
              name="cancelSubmit"
              className="btn btn-secondary mx-2"
              onClick={toggleModal}
            >
              Cancel
            </button>
            <button
              id="sign"
              name="sign"
              className="btn btn-primary"
              onClick={handleClick_sign}
              disabled={fetchingUser}
            >
              <b>Save Signature</b>
            </button>
          </div>
        </ModalFooter>
      </Modal>
      {showAlert_signPadEmpty && (
        <AlertModal
          alertTitle="Signature Empty"
          alertTitleClass="bg-warning"
          alertTitleIcon="exclamation-triangle"
          alertText={"Signature pad is empty."}
          acceptCaption={"OK"}
          acceptClass={"secondary"}
          provideReject={false}
          handleAlertAction={toggelAlert_signPadEmpty}
          toggleAlertModal={toggelAlert_signPadEmpty}
          showAlertModal={showAlert_signPadEmpty}
        />
      )}
    </>
  );
}
